import { Theme } from '@/types/theme'
import { logger } from '@/utils';

let cachedTheme: Theme | null = null;
let cacheTime: number | null = null;

const CACHE_DURATION = 10 * 60 * 1000;
const THEME_NAME = process.env.REACT_APP_THEME_ACTIVE;

if (!THEME_NAME) {
  throw new Error('NEXT_PUBLIC_THEME_NAME is not defined in env');
}

export async function getThemeConfig(): Promise<Theme> {
  const now = Date.now();

    // cache check
  if (cachedTheme && cacheTime && now - cacheTime < CACHE_DURATION) {
    logger.info(`*** Using cached theme ${THEME_NAME} ***`);
    return cachedTheme;
  }

   try {
    //---- کلاینت همیشه از public/theme می‌خواند
    const res = await fetch(`/theme/${THEME_NAME}.json`);

    if (!res.ok) {
      throw new Error(`Failed to fetch theme: ${res.statusText}`);
    }

    const theme = await res.json();

    cachedTheme = theme;
    cacheTime = now;

    logger.info(`*** Fetched theme successfully: ${THEME_NAME} ***`);
    return theme;
  } catch (error) {
    logger.error("[Theme] Error loading theme:", error);
    if (cachedTheme) return cachedTheme;
    throw error;
  }
}
